module.exports = __webpack_public_path__ + "media/images/channels/dermatology-04ffd5bded448bfaf91c121121ff7bf0.jpg";